import {
    ComponentType,
    useMemo,
} from 'react'
import {
    ActionComponentsKey,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import {
    TableFilterParams,
} from 'app/types/common.types'
import CsvUploadButton from 'app/shared-components/BatchActions/CsvUploadButton'
import BatchUpdateButton from 'app/shared-components/BatchActions/BatchUpdateButton'

import CreateButton from '../CreateButton'

type ActionComponentProps = {
    getFilterParams?: () => TableFilterParams
    isMenuItem?: boolean
}

type ActionsMap = Record<ActionComponentsKey, ComponentType<ActionComponentProps> | null>

const actionsMap: ActionsMap = {
    Create: CreateButton,
    Print: null,
    BulkCreate: null,
    BulkEdit: null,
    BatchUpdate: BatchUpdateButton,
    CsvUpload: CsvUploadButton,
}

type Props = {
    toolbarActions: ActionComponentsKey[]
    toolbarActionsProps: ActionComponentProps
}

const useAllowedToolbarActions = ({
    toolbarActions,
    toolbarActionsProps,
}: Readonly<Props>) => {
    return useMemo(() => {
        const allowedActions = Object.keys(actionsMap).reduce((acc, key) => {
            if (toolbarActions?.includes(key as ActionComponentsKey)) {
                acc[key] = actionsMap[key]
            }
            return acc
        }, {}) as ActionsMap

        return Object.values(allowedActions).map((Action) => {
            return (
                <Action
                    getFilterParams={toolbarActionsProps.getFilterParams}
                    isMenuItem={toolbarActionsProps.isMenuItem}
                />
            )
        })
    }, [
        toolbarActions,
        toolbarActionsProps,
    ])
}

export default useAllowedToolbarActions
